import React from 'react';
import { ScreenContainer } from './style';
import { BLUE_WARNING_ICON, RIGHT_TRIANGLE_ICON } from '@Images';
import { IInProgressTransaction } from '../../utils/interface';
import { SEND_MONEY_CALCULATOR_SCREEN } from '../../utils/constants';
import { formatCurrencyAmount } from '@Utils/library';

const InProgressTransaction: React.FC<IInProgressTransaction> = (props) => {
  const { activeTransaction, proceedToTransaction } = props;
  const { inProgressTransaction } = SEND_MONEY_CALCULATOR_SCREEN;

  const message = activeTransaction
    ? `Sending ${formatCurrencyAmount(activeTransaction[0]?.gross_source_amount)} 
  ${activeTransaction[0]?.source_currency} to ${activeTransaction[0]?.full_name}`
    : '';

  return (
    <ScreenContainer>
      <div className="information-card" onClick={proceedToTransaction}>
        <img src={BLUE_WARNING_ICON} alt="warning" height={48} width={48} />

        <div className="text-container">
          <span className="__title">{inProgressTransaction}</span>
          <span className="__description">{message}</span>
        </div>
        <div className="proceed-icon">
          <img src={RIGHT_TRIANGLE_ICON} alt="rightArrow" height="16px" width="16px" />
        </div>
      </div>
    </ScreenContainer>
  );
};

export default InProgressTransaction;
